<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-tabs slider-color="grey">
          <v-tab class="tab" :key="1" ripple>User Details</v-tab>
          <v-tab class="tab" :key="2" ripple>Avatar</v-tab>
          <v-tab class="tab" :key="3" ripple>Roles</v-tab>
          <v-tab class="tab" :disabled="objUserEdit.type != 1" :key="4" ripple>Stores / Departments</v-tab>
          <v-tab class="tab" :disabled="fncCheckDisable()" :key="5" ripple>Regions</v-tab>
          <v-tab class="tab" :disabled="fncCheckDisable()" :key="6" ripple>Limits</v-tab>
          <v-tab class="tab" :disabled="objUserEdit.type != 2" :key="7" ripple>Customer Store Assign</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg4>
                  <label class="blackLabel">Active for MyOrder</label>
                  <v-switch v-model="objUserEdit.active"></v-switch>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Link user to me</label>
                  <v-switch v-model="linkUser"></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* User Type:</label>
                  <v-select :items="linkType" v-model="objUserEdit.type" @input="fncChangeUserType" :rules="userTypeRule" item-value="id" label="User Type" autocomplete solo></v-select>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* First Name</label>
                  <v-text-field label="First Name" class="dropdown" v-model="objUserEdit.name" :rules="firstNameRule" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* Surname</label>
                  <v-text-field label="Surname" class="dropdown" v-model="objUserEdit.surname" :rules="surnameRule" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* Contact No</label>
                  <v-text-field label="Contact No" class="dropdown" :rules="contactNoRule" v-model="objUserEdit.contactno" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* Username (Email Address)</label>
                  <v-text-field label="Email Address" class="dropdown" :rules="usernameRule" v-model="objUserEdit.email" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Alternative Contact No</label>
                  <v-text-field label="Alternative Contact No" class="dropdown" v-model="objUserEdit.alt_contactno" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="objUserEdit.type == 2">
                  <label class="blackLabel">VAT No:</label>
                  <v-text-field label="Vat No" v-model="vatNo" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="objUserEdit.type == 2">
                  <label class="blackLabel">External Account Code</label>
                  <v-text-field label="External Account Code" class="dropdown" v-model="objUserEdit.reference" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3 v-else>
                  <label class="blackLabel">Rep Code</label>
                  <v-text-field label="User Rep Code" class="dropdown" v-model="objUserEdit.reference" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="userAddCompanies != '' && objUserEdit.type != 1 && objUserEdit.type != 6">
                  <label class="blackLabel">Link to Company:</label>
                  <v-select :items="userAddCompanies" v-model="objUserEdit.company" item-value="id" item-text="name" autocomplete label="Company" autocomplete solo></v-select>
                </v-flex>
                <v-flex lg3 v-if="objUserEdit.type == 6">
                  <label class="blackLabel">* Link to Vendor:</label>
                  <v-select :items="userVendors" v-model="objUserEdit.vendor" item-value="id" label="Vendor" autocomplete solo multiple></v-select>
                </v-flex>
                <v-flex lg3 v-if="objUserEdit.type == 2">
                
                  <label class="blackLabel">Trade Customer</label>
                  <v-switch v-model="objUserEdit.is_trade_customer"></v-switch>
                </v-flex>
                <!--<v-flex lg3 v-if="objUserEdit.type == 1">
                  <label class="blackLabel">* Commercial KAM:</label>
                  <v-switch v-model="objUserEdit.is_commercial_kam"></v-switch>
                </v-flex>
                <v-flex lg3 v-if="objUserEdit.type == 1">
                  <label class="blackLabel">* Commercial Co-Ordinator:</label>
                  <v-switch v-model="objUserEdit.is_commercial_originator"></v-switch>
                </v-flex>-->
                <!--<v-flex lg3 v-if="( objAuthorize.branch_active == 1 || objAuthorize.branch_active == true ) && (objUserEdit.type == 1 || objUserEdit.type == 2 || objUserEdit.type == 4 || objUserEdit.type == 6 ) && this.branchList.length != 0">
                  <label class="blackLabel">Link to Store:</label>
                  <v-select :items="branchList" v-model="objUserEdit.branch_id" :rules="branchRule" item-value="id" item-text="name" label="Branch" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg3 v-if="( objAuthorize.department_active == 1 || objAuthorize.department_active == true ) && (objUserEdit.type == 1 || objUserEdit.type == 2 || objUserEdit.type == 4 || objUserEdit.type == 6 ) && this.departmentList.length != 0">
                  <label class="blackLabel">Link to Department:</label>
                  <v-select :items="departmentList" v-model="objUserEdit.department" :rules="departmentRule" item-value="id" item-text="name" label="Department" autocomplete solo></v-select>
                </v-flex>
                <v-flex lg3 v-if="( objAuthorize.branch_active == 1 || objAuthorize.branch_active == true ) && (objUserEdit.type == 1 || objUserEdit.type == 2 || objUserEdit.type  == 4 || objUserEdit.type  == 6 )">
                  <label class="blackLabel">Responsible for Store & Department</label>
                  <v-switch v-model="objUserEdit.is_responsible_department_branch"></v-switch>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl>
              <v-layout row wrap>
              <v-flex lg6>
                    <p>Please select a logo to upload ( Max size: 5mb )</p>
                    <input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
                    <div class="fileHolder">
                      <p>Drag & Drop / Click to Add Files</p>
                      <small>{{ fileName }}</small>
                    </div>
                  </v-flex>
                  <v-flex lg6>                  
                    <p v-if="this.userAvatar == ''"><br /><strong>No avatar has been uploaded</strong></p>
                    <p v-if="this.userAvatar != ''" style="margin-bottom: 5px;"><a @click.prevent="fncResetAvatar" style="clear:both;cursor:pointer;">Remove Avatar</a></p>
                    <img v-if="this.userAvatar != ''" :src="this.userAvatar" width="300" style="margin-top: 0px;" />
                  </v-flex>
                  </v-layout>
                  </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">* Role:</label>
                  <v-select :rules="userRoleRule" :items="userAddRoles" v-model="objUserEdit.user_role" item-value="id" item-text="name" label="Role" autocomplete solo></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-text-field append-icon="search" label="Filter Branches" style="margin-left: 0px !important;" solo single-line v-model="search"></v-text-field>
                </v-flex>
                  <v-flex xs9>
                  <div class="screenTip">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i>
                      Switching on 'Responsible Rep', 'Service Form Rep', and/or 'App Rep' will link the rep to all quotes for that store/department.
                    </span>
                  </div>
                </v-flex>
                <v-flex xs9>
                  <!--<v-btn style="float: right;background: #ddd !important;background-color: #ddd !important" @click="show = !show">View Info</v-btn>-->
                  <v-tooltip @click="show = !show" class="blackTool" v-model="show" top>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sagittis et neque non consectetur. Integer a tempor nisl. Suspendisse potenti. Praesent tincidunt neque sed mi dignissim, ac sodales leo convallis. Praesent volutpat metus ut massa dictum, sed rhoncus erat tincidunt. Nunc commodo massa nec ligula elementum scelerisque. Mauris fermentum odio purus, ac condimentum libero bibendum quis. Pellentesque orci enim, lobortis sit amet volutpat non, luctus sed odio. Quisque quis mi et turpis finibus lobortis. Nullam consequat vel risus vel facilisis. Cras ultrices, lacus non viverra pretium, enim nibh eleifend nunc, at tristique purus magna sit amet ligula. Quisque in malesuada turpis, et mattis odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent placerat diam tellus, non consequat tellus vestibulum nec. Ut semper, ligula in eleifend scelerisque, arcu quam convallis nibh, at condimentum libero ipsum auctor elit.</p>
                    <p>Suspendisse erat risus, scelerisque eget ante ac, sodales mattis sem. Donec quis metus arcu. Mauris vitae risus quis metus ultricies lacinia luctus nec velit. Integer eu faucibus lacus. Nunc arcu sem, posuere quis eros in, commodo feugiat arcu. Nam auctor ligula neque, a varius nunc interdum et. Aliquam molestie dictum diam id semper. Vestibulum id nisl vitae nisi congue fringilla quis in metus. Praesent quis orci non nunc facilisis bibendum non sit amet lacus. Vestibulum consectetur sollicitudin turpis, a aliquet eros fringilla quis. In nulla nunc, ultrices non porta in, sollicitudin quis magna. Nunc aliquam in nisl non tincidunt.</p>
                    <p>Aliquam mi quam, auctor quis consequat ut, scelerisque id nibh. Fusce et ligula luctus, condimentum quam in, rutrum augue. Aenean varius posuere nibh, a iaculis est mollis in. Aenean mollis porta dolor ac eleifend. Duis justo turpis, congue ac dolor vel, rutrum suscipit augue. Nulla euismod turpis in est dignissim fringilla. Quisque volutpat gravida nunc, ac porttitor leo mollis eleifend. Sed egestas augue vitae elit vestibulum hendrerit. Donec suscipit eros ut vulputate tincidunt. Suspendisse venenatis, quam et porttitor faucibus, urna turpis ultricies est, sed molestie neque erat ullamcorper eros. Proin cursus pulvinar lacinia.</p>
                    <p>Duis eu efficitur ligula. Nullam iaculis metus sit amet elit pulvinar elementum. Suspendisse condimentum nisi et augue porttitor fermentum. Phasellus ornare, dui in commodo iaculis, sem lectus efficitur tortor, sit amet convallis orci ipsum ut sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ultricies nisi non diam faucibus lobortis. Proin eget libero aliquet, rhoncus orci id, rutrum quam. Aliquam sit amet sapien venenatis, pulvinar lacus eu, convallis neque.</p>
                    <p>Nulla facilisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris suscipit risus vitae tellus eleifend, quis venenatis nisi congue. Nam condimentum massa a velit dictum auctor. Vivamus dui diam, interdum in commodo id, feugiat non dolor. Duis elementum, erat sed ultrices pretium, quam tellus iaculis diam, aliquet mollis ante arcu viverra urna. Donec elementum ornare erat, non maximus nisi vestibulum a. Nam eros lorem, malesuada nec lorem ac, lacinia scelerisque nisi. Aenean nec fringilla urna. Sed congue eleifend ullamcorper. Praesent in pharetra dolor, a ornare purus.</p>
                    <button @click="show = !show" style="background: black; padding: 10px; width: 100px; color: #fff;">Close</button>
                  </v-tooltip>
                </v-flex>
                <v-data-table :headers="branchHeaders" :search="search" ref="sortableTable" :items="branchesDepartments" hide-actions class="elevation-1 settingTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="15%"><v-switch @change="fncChangeObject()" v-model="props.item.active"></v-switch></td>
                      <td width="20%">{{ props.item.name }}</td>
                      <td width="20%"><v-select style="width:90%;border: none !important;" :items="departmentList" label="Select Departments" v-model="props.item.departments" item-text="name" item-value="id" autocomplete multiple solo></v-select></td>
                      <td width="15%"><v-switch v-model="props.item.responsible_rep"></v-switch></td>
                      <td width="15%"><v-switch v-model="props.item.service_form_rep"></v-switch></td>
                      <td width="15%"><v-switch v-model="props.item.app_rep"></v-switch></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">Show me as Public user contact option in my regions</label>
                  <v-switch v-model="objUserEdit.region_contact"></v-switch>
                </v-flex>
                <v-data-table :headers="regionHeader" v-if="userRegions != ''" id="hello" :items="userRegions" class="elevation-1 mainTable" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="5%"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                      <td v-if="props.expanded == true" width="95%" class="cursor" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                      <td v-else width="95%" class="cursor" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props" class="subTable">
                    <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :items="props.item.children" hide-actions class="elevation-1 subTable subTable1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td width="5%" class="levelone"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                          <td v-if="props.expanded == true" width="95%" class="cursor levelone" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                          <td v-else width="95%" class="cursor levelone" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props" class="subTable">
                        <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :items="props.item.children" hide-actions class="elevation-1 subTable subTable2" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td width="5%" class="leveltwo"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                              <td v-if="props.expanded == true" width="95%" class="cursor leveltwo" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                              <td v-else width="95%" class="cursor leveltwo" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                            </tr>
                          </template>
                          <template slot="expand" slot-scope="props" class="subTable">
                            <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :items="props.item.children" hide-actions class="elevation-1 subTable subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                              <template slot="items" slot-scope="props">
                                <tr>
                                  <td width="5%" class="levelthree"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                                  <td v-if="props.expanded == true" width="95%" class="cursor levelthree" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i>{{ props.item.name }}</td>
                                  <td v-else width="95%" class="cursor levelthree" @click="props.expanded = !props.expanded"><i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_forward</i>{{ props.item.name }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                          </template>
                        </v-data-table>
                      </template>
                    </v-data-table>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <label class="blackLabel">* Maximum Discount %</label>
                  <v-text-field label="Maximum Discount" class="dropdown" v-model="objUserEdit.discount_max" solo single-line></v-text-field>
                </v-flex>
                <!--<v-flex lg6>
                  <label class="blackLabel">* Default Discount %</label>
                  <v-text-field label="First Name" class="dropdown" v-model="objUserEdit.discount_def" solo single-line></v-text-field>
                </v-flex>-->
                <v-flex lg6>
                  <label class="blackLabel">* Maximum Incidental Value</label>
                  <v-text-field label="Maximum Incidental Value" class="dropdown" v-model="objUserEdit.inc_max" solo single-line></v-text-field>
                </v-flex>
                <!--<v-flex lg6>
                  <label class="blackLabel">* Contribution Default %</label>
                  <v-text-field label="First Name" class="dropdown" v-model="objUserEdit.contri_default" solo single-line></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Contribution Minimum %</label>
                  <v-text-field label="First Name" class="dropdown" v-model="objUserEdit.contri_min" solo single-line></v-text-field>
                </v-flex>-->
                <v-flex lg6>
                  <label class="blackLabel">Quote Out Of Stock</label>
                  <v-switch v-model="objUserEdit.quote_out_of_stock"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">GP Manipulation</label>
                  <v-switch v-model="objUserEdit.gp_manipulation"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">GP Manipulation Minimum %</label>
                  <v-text-field label="First Name" class="dropdown" v-model="objUserEdit.gp_manipulation_percentage" solo single-line></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="7">
            <v-container grid-list-xl>            
              <v-layout row wrap>
                <v-flex lg12 v-if="objUserEdit.type == 2">
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddLinkedBranch()">Add Row</v-btn>
                  <v-data-table :headers="listTradeHeaders" :items="objUserEdit.linkedBranches" hide-actions class="elevation-1 subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-select :items="branchList" v-model="props.item.branch" item-value="id" item-text="name" label="Branches" autocomplete solo></v-select>
                        </td>
                        <td>
                          <v-text-field label="Account Number" class="dropdown" v-model="props.item.account_number" solo single-line></v-text-field>
                        </td>
                        <td>                      
                          <v-select :items="pricelistList" v-model="props.item.pricelist" item-value="pl_id" item-text="pl_name" label="Pricelist" autocomplete solo></v-select>
                        </td>
                        <td>
                        <v-select :items="repsShortList" v-model="props.item.trade_rep" item-value="userid" item-text="full_name" label="Trade Rep" autocomplete solo></v-select>
                      </td>
                        <td>
                          <v-btn class="text-xs-right cancelButton" @click.stop="deleteRow(props.index)">Delete</v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <!--<v-select :items="branchList" v-model="linkedBranches" item-value="id" item-text="name" label="Branches" autocomplete solo multiple></v-select>-->
                </v-flex>
                <v-flex lg12 v-else>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddLinkedBranch()">Add Row</v-btn>
                  <v-data-table :headers="listHeaders" :items="objUserEdit.linkedBranches" hide-actions class="elevation-1 subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-select :items="branchList" v-model="props.item.branch" item-value="id" item-text="name" label="Branches" autocomplete solo></v-select>
                        </td>
                        <td>                      
                          <v-select :items="pricelistList" v-model="props.item.pricelist" item-value="pl_id" item-text="pl_name" label="Pricelist" autocomplete solo></v-select>
                        </td>
                        <td>
                          <v-btn class="text-xs-right cancelButton" @click.stop="deleteRow(props.index)">Delete</v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <!--<v-select :items="branchList" v-model="linkedBranches" item-value="id" item-text="name" label="Branches" autocomplete solo multiple></v-select>-->
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-4 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="hasSelectedRegion == false || objUserEdit.user_role == ''" :disabled="true" @click.stop="fncUpdateUser()">Update</v-btn>
            <v-btn color="success" class="text-xs-right" v-if="hasSelectedRegion == true && objUserEdit.user_role != '' && runAdd == false" :disabled="!isAddValid" @click.stop="fncUpdateUser()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed.</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data() {
      return {
        show: false,
        search: '',
        runAdd: false,
        isAddValid: false,
        linkType: [
          /*{ id: 1, text: 'Manufacturer Users' },
          { id: 2, text: 'Customer Users' },
          { id: 3, text: 'Specifier Users' },
          { id: 4, text: 'Public Users' },
          { id: 6, text: 'Vendor Users' }*/
        ],
        headers: [
          { text: '', value: '' },
          { text: 'Level', value: 'level' },
          { text: 'Name', value: 'name' },
          { text: 'Description', value: 'description' }
        ],
        activeMyorder: true,
        linkUser: false,
        userType: '',
        userTypeRule: [
          v => !!v || 'User Type is required',
        ],
        firstName: '',
        firstNameRule: [
          v => !!v || 'First Name is required',
        ],
        surname: '',
        surnameRule: [
          v => !!v || 'Surname is required',
        ],
        contactNo: '',
        contactNoRule: [
          v => !!v || 'Contact No is required',
        ],
        alternativeContactNo: '',
        username: '',
        usernameRule: [
          v => !!v || 'Username is required',
        ],
        password: '',
        passwordRule: [
          v => !!v || 'Password is required',
        ],
        confirmPassword: '',
        conformPasswordRule: [
          v => !!v || 'Please confirm your password',
        ],
        userCompany: '',
        userRole: '',
        userRoleRule: [
          v => !!v || 'User Role is required',
        ],
        maxDiscount: '0.00',
        maxDiscountRuke: [
          v => !!v || 'Maximum Discount is required',
        ],
        defaultDiscount: '0.00',
        defaultDiscountRule: [
          v => !!v || 'Default Discount is required',
        ],
        maxIncidentalValue: '0.00',
        maxIncidentalValueRule: [
          v => !!v || 'Maximum Incidental Value is required',
        ],
        contributionDefault: '0.00',
        contributionDefaultRule: [
          v => !!v || 'User Role is required',
        ],
        contributionMinimum: '',
        regionHeader: [
          { text: 'Select', value: '' },
          { text: 'Name', value: 'name' }
        ],
        listHeaders: [
          { text: 'Branch', value: '' },
          { text: 'Pricelist', value: 'name' },
          { text: '', value: 'name' }
        ],
        listTradeHeaders: [
          { text: 'Branch', value: '' },
          { text: 'Account Number', value: 'name' },
          { text: 'Pricelist', value: 'name' },
          { text: 'Trade Rep', value: 'name' },          
          { text: '', value: 'name' }
        ],
        vatNo: '',
        addressSelected: true,
        branchListSorted: [],
        branchRule: [
          v => !!v || 'Store is required',
        ],
        departmentRule: [
          v => !!v || 'Department is required',
        ],
        branchHeaders: [
          { text: 'Select', value: '', width: '15%' },
          { text: 'Branch', value: 'name', width: '20%' },
          { text: 'Department', value: '', width: '20%' },
          { text: 'Responsible Rep', value: '', width: '15%' },
          { text: 'Service Form Rep', value: '', width: '15%' },
          { text: 'App Rep', value: '', width: '15%' }
        ],
        branchesDepartments: []
      };
    },
    methods: {
      fncResetAvatar() {
            this.$store.commit('fncSetUserAvatar','');
            //this.userAvatar = '';
          },
          fncSetImageObj(e) {
            var files = e.target.files[0] || e.dataTransfer.files[0];
            var fivemeg = 5 * 1000000;
            if (parseInt(files.size) > fivemeg) {
              var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
              this.$store.commit('setSnack', snackDetails);
            } else {
              var vm = this;
              if (files.type == 'video/mp4' || files.type == 'application/pdf' || files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg' || files.type == 'application/pdf' || files.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files.type == 'application/vnd.ms-excel' || files.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files.type == 'application/msword' || files.type == 'application/x-zip-compressed' || files.type == 'text/plain') {
                this.fileObj = files;
                var currentInput = document.getElementById('quoteFile');
                currentInput.value = '';
                this.$store.dispatch({
                  type: 'fncUploadAvatar',
                  files: files
                })
              } else {
                var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
                this.$store.commit('setSnack', snackDetails);
              }
            }
          },
      deleteRow(index) {
        this.objUserEdit.linkedBranches.splice(index, 1);
      },
      fncAddLinkedBranch() {

        this.objUserEdit.linkedBranches.push({branch: 0, pricelist: 0})
      },
      fncChangeObject() {
        var toPush = [];

        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == true ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }
        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == false ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }

        this.branchesDepartments = toPush;

      },
      fncCheckDisable() {
        if( this.objAuthorize.manufacturer == '385889803' ) {
          return false;
        } else {
          return false;
        }
      },
      fncGetDepartments() {
        this.branchListSorted = [];
        for( var d in this.departmentList ) {
          for (var b in this.departmentList[d].branch) {
            if (this.objUserEdit.branch_id.indexOf(this.departmentList[d].branch[b]) != -1) {
              this.branchListSorted.push(this.departmentList[d]);
            }
          }
        }
        if( this.objUserEdit.branch_id.length == 0 ) {
          this.objUserEdit.department = [];
        }
      },
      fncHideModal() {
        this.$store.commit('hideModal');
        //window.location.reload();
      },
      fncChangeUserType() {
        //this.$store.dispatch('fncResetSetupUserCreate', this.userType);
        var companyType = this.objUserEdit.type == 2 ? 1 : 2;
        this.$store.dispatch({
          type: 'fncResetSetupUserCreate',
          companyType: companyType,
          userType: this.objUserEdit.type
        });
      },
      fncUpdateUser() {

        this.runAdd = true;
        this.objUserEdit.branchesDepartments = this.branchesDepartments;
        this.objUserEdit.avatar = this.userAvatar;

        var bdActive = [];
        for( var bd in this.branchesDepartments ) {
          if( this.branchesDepartments[bd].active == true || this.branchesDepartments[bd].active == 1 ) {
            bdActive.push(this.branchesDepartments[bd]);
          }
        }
        this.objUserEdit.branchesDepartments = bdActive;
        this.$store.dispatch('fncUpdateUser', this.objUserEdit);
      },
      fncCheckRegionSetup(regionId, regionStatus, regionParent) {
        this.addressSelected = true;
        this.$store.commit({
          type: 'fncCheckRegionSetup',
          regionId: regionId,
          regionStatus: regionStatus,
          parent: regionParent
        })
        if (regionStatus == false) {
          this.$store.commit('fncHideRegionParent', regionParent)
        }
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'regionSelectors',
        'userAddRoles',
        'userAddCompanies',
        'objUserEdit',
        'userVendors',
        'userRegions',
        'branchList',
        'departmentList',
        'userBranchesDepartments',
        'pricelistList',
        'userAvatar',
        'repsShortList'
      ]),
      hasSelectedRegion() {
        if (this.userRegions == '' || this.userRegions == null) {
          return false;
        }
        for (var c in this.userRegions) {
          if (this.userRegions[c].selected == true) {
            return true;
          }
          for (var p in this.userRegions[c].children) {
            if (this.userRegions[c].children[p].selected == true) {
              return true;
            }
            for (var t in this.userRegions[c].children[p].children) {
              if (this.userRegions[c].children[p].children[t].selected == true) {
                return true;
              }
              for (var s in this.userRegions[c].children[p].children[t].children) {
                if (this.userRegions[c].children[p].children[t].children[s].selected == true) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      }
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateBranches');
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulatePricelistList');
    },
    mounted() {
      var toPush = [];
      for( var b in this.branchList ) {
        if( this.branchList[b].id != '' ) {
          if( this.userBranchesDepartments[this.branchList[b].id] != null ) {
            var isResponsible = this.userBranchesDepartments[this.branchList[b].id].is_responsible == 1 ? true : false;
            var serviceFormRep = this.userBranchesDepartments[this.branchList[b].id].service_form_rep == 1 ? true : false;
            var appRep = this.userBranchesDepartments[this.branchList[b].id].app_rep == 1 ? true : false;
            var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: true, responsible_rep: isResponsible, departments: this.userBranchesDepartments[this.branchList[b].id].departments, service_form_rep: serviceFormRep, app_rep: appRep };
            toPush.push( miniPush );
          } else {
            var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [], service_form_rep: false, app_rep: false };
            toPush.push( miniPush );
          }
        }
      }

      this.branchesDepartments = toPush;
      var toPush = [];

      for( var b in this.branchesDepartments ) {
        if( this.branchesDepartments[b].active == true ) {
          toPush.push( this.branchesDepartments[b] );
        }
      }
      for( var b in this.branchesDepartments ) {
        if( this.branchesDepartments[b].active == false ) {
          toPush.push( this.branchesDepartments[b] );
        }
      }

      this.branchesDepartments = toPush;

      if( this.objUserEdit.linkedBranches.length > 0 ) {
        for( var lb in this.objUserEdit.linkedBranches ) {

          this.objUserEdit.linkedBranches[lb].branch = parseInt( this.objUserEdit.linkedBranches[lb].branch );
          this.objUserEdit.linkedBranches[lb].pricelist = this.objUserEdit.linkedBranches[lb].pricelist;

        }
      }
    },
    watch: {
      userBranchesDepartments() {
        var toPush = [];
        for( var b in this.branchList ) {
          if( this.branchList[b].id != '' ) {
            if( this.userBranchesDepartments[this.branchList[b].id] != null ) {
              var isResponsible = this.userBranchesDepartments[this.branchList[b].id].is_responsible == 1 ? true : false;
              var serviceFormRep = this.userBranchesDepartments[this.branchList[b].id].service_form_rep == 1 ? true : false;
              var appRep = this.userBranchesDepartments[this.branchList[b].id].app_rep == 1 ? true : false;
              var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: true, responsible_rep: isResponsible, departments: this.userBranchesDepartments[this.branchList[b].id].departments, service_form_rep: serviceFormRep, app_rep: appRep };
              toPush.push( miniPush );
            } else {
              var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [], service_form_rep: false, app_rep: false };
              toPush.push( miniPush );
            }
          }
        }

        this.branchesDepartments = toPush;
        var toPush = [];

        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == true ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }
        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == false ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }

        this.branchesDepartments = toPush;
      }
    },
    created() {
      this.$store.dispatch('fncPopulateRegionList');
      this.fncChangeUserType(this.objUserEdit.type);

      this.linkType = [{ id: 1, text: this.objAuthorize.manu_user_alias }];

      if (this.objAuthorize.privileges.indexOf('HIDE_CUSTOMER_USERS') == -1) {
        this.linkType.push({ id: 2, text: this.objAuthorize.customer_user_alias });
      }

      if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
        this.linkType.push({ id: 3, text: this.objAuthorize.specifier_user_alias });
      }

      if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
        this.linkType.push({ id: 4, text: this.objAuthorize.public_user_alias });
      }

      if (this.objAuthorize.privileges.indexOf('HIDE_VENDOR_USERS') == -1) {
        this.linkType.push({ id: 6, text: 'Vendor Users' });
      }

      this.objUserEdit.name = this.objUserEdit.name.replace(/"/g, '');
      this.objUserEdit.surname = this.objUserEdit.surname.replace(/"/g, '');

      /*this.branchListSorted = [];
      if( this.objUserEdit.branch_id != null ) {
        for( var d in this.departmentList ) {
          for (var b in this.departmentList[d].branch) {
            if (this.objUserEdit.branch_id.indexOf(this.departmentList[d].branch[b]) != -1) {
              this.branchListSorted.push(this.departmentList[d]);
            }
          }
        }
      }*/
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
